import { render, staticRenderFns } from "./DashboardFunctionalButtons.vue?vue&type=template&id=2af5d121&scoped=true"
import script from "./DashboardFunctionalButtons.vue?vue&type=script&lang=js"
export * from "./DashboardFunctionalButtons.vue?vue&type=script&lang=js"
import style0 from "./DashboardFunctionalButtons.vue?vue&type=style&index=0&id=2af5d121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5d121",
  null
  
)

export default component.exports